import { app } from '../../../bootstrap/core';
import { descriptiveBoxComponent } from './descriptiveBox.component';

app.component('descriptiveBox', descriptiveBoxComponent);
